(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('PolicyAnagDeleteController',PolicyAnagDeleteController);

    PolicyAnagDeleteController.$inject = ['$uibModalInstance', 'entity', 'PolicyAnag'];

    function PolicyAnagDeleteController($uibModalInstance, entity, PolicyAnag) {
        var vm = this;

        vm.policy = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PolicyAnag.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
